const ISO8601regex = /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)D)?T?(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/;

App.filter('duration', function() {
  return function(duration) {
    if (duration === undefined) {
      return ''
    }

    const matches = duration.match(ISO8601regex);

    const parts = {
      year: parseInt(matches[1]) || 0,
      month: parseInt(matches[2]) || 0,
      day: parseInt(matches[3]) || 0,
      hour: parseInt(matches[4]) || 0,
      minute: parseInt(matches[5]) || 0,
      second: parseInt(matches[6]) || 0,
    };

    let result = [];
    if (parts.year) result.push(parts.year + ' year' + (parts.year > 1 ? 's' : ''));
    if (parts.month) result.push(parts.month + ' month' + (parts.month > 1 ? 's' : ''));
    if (parts.day) result.push(parts.day + ' day' + (parts.day > 1 ? 's' : ''));
    if (parts.hour) result.push(parts.hour + ' hour' + (parts.hour > 1 ? 's' : ''));
    if (parts.minute) result.push(parts.minute + ' minute' + (parts.minute > 1 ? 's' : ''));
    if (parts.second) result.push(parts.second + ' second' + (parts.second > 1 ? 's' : ''));

    return result.join(', ');
  };
})
